import * as React from 'react'
import { SVGProps } from 'react'
const SvgReturnIconCart = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M7.714 13.627a.5.5 0 1 0 0 1v-1Zm-6.068-7.98a.5.5 0 0 0 0 .707l3.182 3.182a.5.5 0 1 0 .708-.708L2.707 6l2.829-2.828a.5.5 0 1 0-.708-.708L1.646 5.646Zm6.068 8.98h6.223v-1H7.714v1ZM13.937 5.5H2v1h11.937v-1Zm4.563 4.563A4.563 4.563 0 0 0 13.937 5.5v1a3.563 3.563 0 0 1 3.563 3.563h1Zm-4.563 4.564a4.564 4.564 0 0 0 4.563-4.564h-1a3.563 3.563 0 0 1-3.563 3.564v1Z"
      fill="var(--black, #1C1915)"
    />
  </svg>
)
export default SvgReturnIconCart
